export const tableHeaders = [
    {
        title: 'store_name',
        value: 'storeName',
        sortable: false,
        width: 220,
    },
    {
        title: 'ceo_name',
        value: 'ceoName',
        sortable: false,
        width: 128,
    },
    {
        title: 'business_number',
        value: 'businessNumber',
        sortable: false,
        width: 128,
    },
    {
        title: 'business_address',
        value: 'businessAddress',
        sortable: false,
        width: 439,
    },
    {
        title: 'business_type',
        value: 'businessType',
        sortable: false,
        width: 164,
    },
    {
        title: 'business_condition',
        value: 'businessCondition',
        sortable: false,
        width: 128,
    },
    {
        title: 'ceo_email',
        value: 'ceoEmail',
        sortable: false,
        width: 260,
    },
    {
        title: 'order_count',
        value: 'orderCount',
        sortable: true,
        width: 102,
    },
    {
        title: 'total_amount',
        value: 'totalAmount',
        sortable: true,
        align: 'end',
    },
];
// 검색란 검색유형
export const searchFieldTypeOptions = [
    {
        title: '상점명',
        value: 'STORE_NAME',
        field: 'storeName',
    },
];
